/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/camera_medium'
export default icon
